/**
 * REF: https://github.com/webedx-spark/service-definitions/blob/123c7dd4f88b45bf305ba38ce09b8f0cd98b3480/coursera/proto/sharedpayments/v1/payment_processor_id.proto
 */
const paymentProcessorIdObject = {
  PAYMENT_PROCESSOR_ID_INVALID: 'PAYMENT_PROCESSOR_ID_INVALID',
  PAYMENT_PROCESSOR_ID_MOCK: 'PAYMENT_PROCESSOR_ID_MOCK',
  PAYMENT_PROCESSOR_ID_BRAINTREE: 'PAYMENT_PROCESSOR_ID_BRAINTREE',
  PAYMENT_PROCESSOR_ID_BRAINTREE_SANDBOX: 'PAYMENT_PROCESSOR_ID_BRAINTREE_SANDBOX',
  /**
   * PAYMENT_PROCESSOR_ID_FINANCIAL_AID - Since 2023-02-02 we are opting for the `ZeroDollarPaymentProcessor` for checking out financial aid applications.
   * We hope to eventually deprecate `FinancialAidPaymentProcessor` which will reduce duplication since it does a relatively similar thing to `ZeroDollarPaymentProcessor`.
   * For details: https://docs.google.com/document/d/1Q1EUuMvLbhn05xwa4huUoNeYLyyeFnXWXnw4hYyRqsY/edit?usp=sharing
   *
   * @deprecated
   */
  PAYMENT_PROCESSOR_ID_FINANCIAL_AID: 'PAYMENT_PROCESSOR_ID_FINANCIAL_AID',
  PAYMENT_PROCESSOR_ID_ZERO_DOLLAR: 'PAYMENT_PROCESSOR_ID_ZERO_DOLLAR',
  PAYMENT_PROCESSOR_ID_APPLE_INAPP: 'PAYMENT_PROCESSOR_ID_APPLE_INAPP',
  PAYMENT_PROCESSOR_ID_APPLE_INAPP_SANDBOX: 'PAYMENT_PROCESSOR_ID_APPLE_INAPP_SANDBOX',
  /** PAYMENT_PROCESSOR_ID_STRIPE - These Stripe ID is for WES invoicing */
  PAYMENT_PROCESSOR_ID_STRIPE: 'PAYMENT_PROCESSOR_ID_STRIPE',
  PAYMENT_PROCESSOR_ID_STRIPE_SANDBOX: 'PAYMENT_PROCESSOR_ID_STRIPE_SANDBOX',
  PAYMENT_PROCESSOR_ID_PAYPAL: 'PAYMENT_PROCESSOR_ID_PAYPAL',
  PAYMENT_PROCESSOR_ID_COURSERA_MANUAL: 'PAYMENT_PROCESSOR_ID_COURSERA_MANUAL',
  /** @deprecated */
  PAYMENT_PROCESSOR_ID_EMERGENT: 'PAYMENT_PROCESSOR_ID_EMERGENT',
  /** @deprecated */
  PAYMENT_PROCESSOR_ID_EMERGENT_SANDBOX: 'PAYMENT_PROCESSOR_ID_EMERGENT_SANDBOX',
  PAYMENT_PROCESSOR_ID_EBANX: 'PAYMENT_PROCESSOR_ID_EBANX',
  PAYMENT_PROCESSOR_ID_EBANX_SANDBOX: 'PAYMENT_PROCESSOR_ID_EBANX_SANDBOX',
  PAYMENT_PROCESSOR_ID_RAZORPAY: 'PAYMENT_PROCESSOR_ID_RAZORPAY',
  PAYMENT_PROCESSOR_ID_RAZORPAY_SANDBOX: 'PAYMENT_PROCESSOR_ID_RAZORPAY_SANDBOX',
  PAYMENT_PROCESSOR_ID_GOOGLE_PLAY: 'PAYMENT_PROCESSOR_ID_GOOGLE_PLAY',
  /** PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER - These Stripe ID is for processing consumer transactions */
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER: 'PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER',
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX: 'PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX',
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER: 'PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER',
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX: 'PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX',
  PAYMENT_PROCESSOR_ID_RAZORPAY_CHARGE_AT_WILL: 'PAYMENT_PROCESSOR_ID_RAZORPAY_CHARGE_AT_WILL',
  PAYMENT_PROCESSOR_ID_RAZORPAY_CHARGE_AT_WILL_SANDBOX: 'PAYMENT_PROCESSOR_ID_RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  UNRECOGNIZED: 'UNRECOGNIZED',
} as const;

export default paymentProcessorIdObject;

export const {
  PAYMENT_PROCESSOR_ID_INVALID,
  PAYMENT_PROCESSOR_ID_MOCK,
  PAYMENT_PROCESSOR_ID_BRAINTREE,
  PAYMENT_PROCESSOR_ID_BRAINTREE_SANDBOX,
  PAYMENT_PROCESSOR_ID_APPLE_INAPP,
  PAYMENT_PROCESSOR_ID_APPLE_INAPP_SANDBOX,
  PAYMENT_PROCESSOR_ID_COURSERA_MANUAL,
  PAYMENT_PROCESSOR_ID_EBANX,
  PAYMENT_PROCESSOR_ID_EBANX_SANDBOX,
  PAYMENT_PROCESSOR_ID_GOOGLE_PLAY,
  PAYMENT_PROCESSOR_ID_PAYPAL,
  PAYMENT_PROCESSOR_ID_RAZORPAY,
  PAYMENT_PROCESSOR_ID_RAZORPAY_SANDBOX,
  PAYMENT_PROCESSOR_ID_STRIPE,
  PAYMENT_PROCESSOR_ID_STRIPE_SANDBOX,
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER,
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX,
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER,
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX,
  PAYMENT_PROCESSOR_ID_ZERO_DOLLAR,
  PAYMENT_PROCESSOR_ID_EMERGENT,
  PAYMENT_PROCESSOR_ID_EMERGENT_SANDBOX,
  PAYMENT_PROCESSOR_ID_FINANCIAL_AID,
  PAYMENT_PROCESSOR_ID_RAZORPAY_CHARGE_AT_WILL,
  PAYMENT_PROCESSOR_ID_RAZORPAY_CHARGE_AT_WILL_SANDBOX,
  UNRECOGNIZED,
} = paymentProcessorIdObject;

export type PaymentProcessorId = (typeof paymentProcessorIdObject)[keyof typeof paymentProcessorIdObject];
